import { createTheme } from '@mui/material/styles';
import {CacheProvider} from "@emotion/react";
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import wSiteFont from "../../files/fonts/IRANSansWeb.woff2";
import {useTranslation} from "react-i18next";


// Create rtl cache
const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
});
const WSiteFont = {
    fontFamily: 'wSiteFont',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
    local('wSiteFont'),
    local('wSiteFont'),
    url(${wSiteFont}) format('woff2')`
};
export function Rtl({ children }) {
    const { i18n } = useTranslation();
    const dir = i18n.dir();
    if (dir === 'rtl') {
        return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
    }
    return <>{children}</>; // no wrapper for ltr
}
export function getDirection(){
    const savedLang = localStorage.getItem('language') || 'tr';
    const dir = ['fa', 'ar', 'he', 'ur'].includes(savedLang) ? 'rtl' : 'ltr';
    return dir;
}
export let theme = createTheme({
    palette: {
        primary: {
            main: '#F0051F',
        },
        secondary: {
            main: '#489E21',
        },
        field: {
            main: "#212121",
        },
        text:{
            main: "#212121",
        },
        gray:{
            main: "#eee",
        },
        grayDark:{
            main: "#666666",
        },
        lightRed:{
            main:"#fdf4f5"
        },
        lightSecondary:{
            main:"#e3ffd6"
        },
    },
    typography: {
        fontFamily: 'wSiteFont, Tahoma',
        lineHeight: 1.8,
        htmlFontSize: 19,
        h5: {
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#333',
            lineHeight: 1.2,
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [WSiteFont],
            },

        },

    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize:'14px',
                    boxShadow:'none'
                },
                sizeLarge: {
                    lineHeight: '2.5',
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    padding:"8px 15px",
                    "& .MuiAlert-action":{
                        paddingTop:0
                    }
                },

            },
        },
    },
    direction:  getDirection(),
});